var styles = {"label":"Label-module_label__Wcze3","secondary":"Label-module_secondary__IssgZ","error":"Label-module_error__SixIJ"};

export { styles as default };
//# sourceMappingURL=Label.module.scss.js.map
